import { useState, useEffect } from 'react';

const useCorClaraOuEscura = (corInicial: string) => {
    const [luminosidade, setLuminosidade] = useState<TLuminosidade>("clara");

    useEffect(() => {
        function calcularLuminosidade(cor: string) {
            let r = parseInt(cor.substring(1, 3), 16);
            let g = parseInt(cor.substring(3, 5), 16);
            let b = parseInt(cor.substring(5, 7), 16);

            let brilho = (r * 299 + g * 587 + b * 114) / 1000;

            return brilho > 192 ? 'clara' : 'escura';
        }

        setLuminosidade(calcularLuminosidade(corInicial));
    }, [corInicial]);

    return luminosidade;
}

type TLuminosidade = "clara" | "escura"

export default useCorClaraOuEscura;